"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandViolation = function LandViolation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 24 24", className: "custom-icon" }, props),
    _react2.default.createElement("path", {
      d: "M10.464 22.992c-.354-.03-.787-.083-1.063-.13a11.021 11.021 0 0 1-8.607-7.295 11.634 11.634 0 0 1-.535-2.397c-.056-.465-.056-1.878 0-2.343.304-2.55 1.344-4.749 3.088-6.532 1.791-1.832 4.071-2.94 6.698-3.253.465-.056 1.879-.056 2.344 0 2.627.313 4.907 1.42 6.698 3.253 1.744 1.783 2.784 3.982 3.088 6.532.056.465.056 1.878 0 2.343-.304 2.55-1.344 4.749-3.088 6.532-1.788 1.829-4.076 2.941-6.687 3.252-.275.032-1.676.06-1.936.038zm1.58-2.77a8.315 8.315 0 0 0 3.967-1.488c.01-.009-11.505-11.53-11.524-11.53a8.242 8.242 0 0 0-1.494 3.966c-.042.396-.042 1.26 0 1.656a8.273 8.273 0 0 0 3.612 6.03 8.352 8.352 0 0 0 3.756 1.364c.37.04 1.308.041 1.684.001zm6.078-3.682a8.242 8.242 0 0 0 1.32-3.714c.04-.396.04-1.26 0-1.655a8.273 8.273 0 0 0-3.613-6.031 8.31 8.31 0 0 0-3.784-1.364 10.933 10.933 0 0 0-1.656 0 8.315 8.315 0 0 0-3.966 1.487c-.01.009 11.505 11.53 11.524 11.53.006-.001.084-.115.175-.253z",
      id: "a"
    }),
    _react2.default.createElement("path", {
      d: "M10.587 2.06l.307.227a.215.215 0 0 1 .083.15v1.816a.215.215 0 0 1-.083.149l-.307.226a.4.4 0 0 1-.202.062H5.466a.4.4 0 0 1-.202-.062l-.307-.226a.215.215 0 0 1-.084-.149V2.436c0-.048.038-.115.084-.149l.307-.226a.4.4 0 0 1 .202-.062H10.385a.4.4 0 0 1 .202.062zm-4.113-.695v-.239c0-.074.13-.136.29-.136h2.025c.16 0 .29.062.29.136v.239H6.474zm0 4.001H9.08v9.307c0 .148-.131.27-.29.27H6.764c-.16 0-.29-.122-.29-.27V5.366z",
      id: "c"
    })
  );
};

exports.default = LandViolation;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/landviolations.js
// module id = ../lib/egov-ui-kit/custom-icons/landviolations.js
// module chunks = 504